import { render, staticRenderFns } from "./ModulesPopup.vue?vue&type=template&id=0430f063&"
import script from "./ModulesPopup.vue?vue&type=script&lang=js&"
export * from "./ModulesPopup.vue?vue&type=script&lang=js&"
import style0 from "./modules-popup.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports